import React from 'react';
import { connect } from 'react-redux';

import Select from '@/components/common/Select/Select';
import Axios from '@/axiosPool';

@connect((store) => {
  return {
    loggedUser: store.loggedUser,
  };
})
class Workstreams extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      selected: {},
      page: 1,
      name: null,
    };
    _.map(
      [
        'fetchWorkstreamList',
        'onRenderOption',
        'handleClear',
        'handleSearch',
        'handleLoadMore',
      ],
      (fn) => {
        this[fn] = this[fn].bind(this);
      }
    );
  }
  componentDidMount() {
    const { defaultSelected, timelog } = this.props;
    if (defaultSelected) {
      this.setState({ selected: defaultSelected, onload: true });
    }
    if (timelog.selected.account) {
      this.fetchWorkstreamList();
    }
  }
  componentDidUpdate(prev) {
    const { timelog, defaultSelected } = this.props;
    //for add

    if (
      !_.isEqual(prev.timelog.selected.account, timelog.selected.account) &&
      !timelog.selected.workstream
    ) {
      this.setState({ selected: {}, name: null }, () => {
        this.fetchWorkstreamList();
      });
    }
    if (!_.isEqual(prev.defaultSelected, defaultSelected) && defaultSelected) {
      this.setState({ selected: defaultSelected });
    }
  }
  fetchWorkstreamList() {
    const { loggedUser, timelog } = this.props;
    const selected = timelog.selected;
    const params = {
      projectId: selected.account,
      page: this.state.page,
      name: this.state.name,
    };
    if (selected && selected.account) {
      Axios.get('api/workstream/getUserWorkstreamList', params).then((res) => {
        if (res) {
          const newList = res.data.results.map((e) => {
            return {
              value: e.id,
              label: e.workstream,
              color: e.color,
            };
          });
          this.setState({
            count: res.data.count,
            list:
              this.state.page < 2 ? newList : [...this.state.list, ...newList],
          });
        }
      });
    }
  }

  handleClear() {
    const { onChange } = this.props;
    if (onChange) {
      this.setState({ selected: {} }, () => {
        onChange({ name: 'workstream', value: null });
      });
    }
  }

  onRenderOption(option) {
    return (
      <div class="account-item">
        <div
          class="account-status"
          style={{ backgroundColor: option.color }}
        ></div>
        <div class="account-name">
          <span>
            {option.label.length > 22
              ? `${option.label.substring(0, 22)}...`
              : option.label}
          </span>
        </div>
      </div>
    );
  }
  handleSearch(value) {
    this.setState({ name: value, page: 1 }, () => {
      this.fetchWorkstreamList();
    });
  }
  handleLoadMore() {
    this.setState(
      {
        page: this.state.page + 1,
      },
      () => {
        this.fetchWorkstreamList();
      }
    );
  }
  render() {
    const {
      onChange,
      defaultSelected,
      timelog,
      defaultValue,
      optClasses = '',
    } = this.props;
    const { list, selected } = this.state;
    const onSelect = (e) => {
      if (onChange) {
        this.setState({ selected: e, name: null }, () => {
          onChange({ name: 'workstream', value: e.value });
        });
      }
    };
    const optionList = _.orderBy(
      _.uniqBy(
        [...(defaultSelected ? [defaultSelected] : []), ...list],
        'value'
      ),
      ['label'],
      'asc'
    );
    return (
      <div>
        {defaultValue ? (
          <p class="defaultValue">{defaultValue}</p>
        ) : (
          <Select
            isSearchable={true}
            classes={{
              options: `timelogSelectOptions timelogWorkstream ${optClasses}`,
            }}
            placeholder="Select Workstream"
            onChange={onSelect}
            options={optionList}
            onClearSelected={this.handleClear}
            selected={selected}
            onSearch={this.handleSearch}
            count={10}
            isFirstItemSelected={false}
            renderOption={this.onRenderOption}
            disabled={!timelog.selected.account}
            bottomContent={
              this.state.count > optionList.length ? (
                <div>
                  <p class="mb0 loadMoreContainer">
                    <a onClick={this.handleLoadMore}>Load More</a>
                  </p>
                </div>
              ) : (
                <div></div>
              )
            }
          />
        )}
      </div>
    );
  }
}

export default Workstreams;
